<template>
<div class="container">
<ccLoading v-show="loading" ref="cc_loading"></ccLoading>
<!-- <div class="row">
  <div class="col-12 text_branco">
    Carregando .........
  </div>
</div> -->
</div>
</template>

<script>
import axios from 'axios';
import ccLoading from '../cc_geral/cc_loading.vue'

export default {
  data () {
    return {
      //geral
      base_url_api: process.env.BASE_URL_API,
      user: {},
      loading: true,
      errors: [],
    }
  },

  components: {ccLoading},

  created(){
    localStorage.setItem("base_url_api_mobile", this.base_url_api);
  },

  mounted(){
    let a = JSON.parse(localStorage.getItem("user"));

    if (a == null){
      this.user = {}
      this.expluse_para_login()
    }else{
      this.user = a
    }

    this.get_disparo()
  },

  methods: {

    get_disparo(){
      this.loading = true;
      var header = {'headers': {'x-access-token': this.user.access_token, }};
      axios.get(this.base_url_api+'user/torneio/disparo', header)
      .then(response => {
        let disparo = response.data
        this.$router.push({ path: 'meu_torneio/'+ (disparo == 1 ? 'aguardando' : disparo == 2 ? 'andamento' : 'historico'), replace: true })
        // this.loading = false
      })
      .catch(e => {
        this.errors.push(e);
        this.expluse_para_login()
      });
    },

  },

}

</script>


// WEBPACK FOOTER //
// src/components/meu/meu_torneio_disparo.vue